import React, { useState } from "react";
import Header from "../../../../components/Layout/Header/Header";
import { PageContainer } from "../../../../components/Layout/Container/PageContainer";
import { PageHeader } from "../../../../components/Layout/Shared/PageHeader";
import { PageTitle } from "../../../../components/Layout/Shared/PageTitle";
import { HeaderButtons } from "../../../../components/Layout/Shared/PageHeader/HeaderButtons";
import { CustomButton } from "../../../../components/Layout/Shared/Button";
import { PieChartIcon } from "../../../../assets/icons/icon";
import { AddNewClient } from "../../../../components/Clients/Create";
import { useHistory } from "react-router-dom";
import { GenericPageLeft } from "../../../../components/Layout/Shared/GenericPageLeft";
import "./index.scss";
import { BusinessClientCreateProvider } from "../../../../providers/Client/create";
import { ImportClientManager } from "../../../../components/Clients/ImportClientManager";

const CreateClientPage = () => {
  const history = useHistory();
  const goToCreateNewContact = () => history.push(`/business/client/create`);
  const goToContactList = () => history.push(`/business/client/list`);
  const [showImport, setShowImport] = useState(false);

  return (
    <BusinessClientCreateProvider>
      <section className="dashboard  bg-paleGray pb-5 pr-3">
        <Header />
        <div className="container-fluid mt-5 pt-3 create-new-contact">
          <div className="row">
            <GenericPageLeft />
            <PageContainer>
              <PageHeader>
                <PageTitle>CLIENTS</PageTitle>
                <HeaderButtons>
                  <CustomButton
                    color="transparent"
                    title="Migrate Client from Contacts"
                    size="200px"
                    onClick={() => setShowImport(true)}
                  />
                  <CustomButton
                    color="blue"
                    title="Invite Client"
                    size="150px"
                    onClick={goToCreateNewContact}
                  />
                  <button className="btn btn-icon">
                    {PieChartIcon} Analytics
                  </button>
                </HeaderButtons>
              </PageHeader>
              <AddNewClient />
              <ImportClientManager
                show={showImport}
                setShow={setShowImport}
                refresh={goToContactList}
              />
            </PageContainer>
          </div>
        </div>
      </section>
    </BusinessClientCreateProvider>
  );
};

export default CreateClientPage;
